import React, { useState } from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import { useTranslation } from 'react-i18next';
import RebarProjectPurchasableContainer from '../../../components/ProjectPurchase/RebarProjectPurchasableContainer';
import { useRebarProjectInfoStore } from '../../../stores/rebarProjectInfoStore';
import { checkProjectActivationOrPermission } from '../../../other/utilFunctions';

const ProjectDetails = ({
    projectCreationTime,
    id,
    name,
    theoreticalWeight,
    theoreticalLength,
    user,
    uploadedFileType,
    activated,
    priceCalculationMethod,
    unitPrice,
    unitDiscount,
    unitPriceType,
    purchasable,
    userType,
    ownProject
}) => {
    const { i18n, t } = useTranslation();

    const [dialogOpen, setDialogOpen] = useState(false)
    const [dialogContent, setDialogContent] = useState(<div></div>)

    const cuttingPlanPermission = useRebarProjectInfoStore((state) => state.projectCuttingPlanPermission);

    let creationTime = new Date(projectCreationTime).toLocaleDateString(`${i18n.language}-${i18n.language.toUpperCase()}`);

    let price_calculation_value, unit_of_unit_price, unit_of_calculation_method
    if (priceCalculationMethod === 'weight_per_1ton') {
        price_calculation_value = theoreticalWeight
        unit_of_unit_price = '₺/ton'
        unit_of_calculation_method = 'ton'
    }
    else {
        price_calculation_value = theoreticalLength
        unit_of_unit_price = '₺/1000m'
        unit_of_calculation_method = 'x1000m'
    }

    const pname = name === "Ornek-Proje" ? t("Ornek-Proje") : name

    return (
        <>
            {dialogOpen &&
                <Dialog
                    maxWidth="xs"
                    fullWidth={true}
                    open={dialogOpen}
                    onClose={() => setDialogOpen(false)}>
                    <DialogContent>
                        {dialogContent}
                    </DialogContent>
                </Dialog>}
            <Container className='border border-top-0 p-3' fluid style={{ backgroundColor: 'white' }}>
                <h3 className="text-center d-block d-md-none">{t("Proje Bilgileri")}</h3>
                <Row>
                    <Col md={{ offset: 2, span: 8 }}>
                        <table className="table table-striped-columns border my-3 align-middle bg-white">
                            <tbody>
                                <tr>
                                    <th style={{ width: "45%" }}>{t("Proje Numarası")}</th>
                                    <td style={{ width: "65%" }}>{id}</td>
                                </tr>
                                <tr>
                                    <th>{t("Proje İsmi")}</th>
                                    <td>{pname}</td>
                                </tr>
                                <tr>
                                    <th>{t("Kullanıcı")}</th>
                                    <td>{user}</td>
                                </tr>
                                <tr>
                                    <th>{t("Oluşturma Zamanı")}</th>
                                    <td>{creationTime}</td>
                                </tr>
                                <tr>
                                    <th>{t("Yüklenen Dosya Tipi")}</th>
                                    <td>{uploadedFileType}</td>
                                </tr>
                                <tr>
                                    <th>{t("Toplam Teorik Ağırlık (kg)")}</th>
                                    <td>{theoreticalWeight}</td>
                                </tr>
                                <tr>
                                    <th>{t("Aktive Edildi mi?")}</th>
                                    <td>{activated ? t("Evet") : t("Hayır")}</td>
                                </tr>
                            </tbody>
                        </table>

                    </Col>
                </Row>

            </Container>
        </>
    )
}

export default ProjectDetails;
